// ./src/styles/GlobalStyles.tsx
import { createGlobalStyle } from "styled-components";

// FormSubmits Typography
// - Space Grotesk: Headings (geometric, technical, distinctive)
// - IBM Plex Sans: Body text (clean, readable, professional)
// - IBM Plex Mono: Code blocks (consistent with Plex family)
export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600&display=swap');

  /* CSS Reset and Base Styles */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    height: 100%;
  }

  #root {
    height: 100%;
    min-height: 100vh;
  }

  /* Remove default button focus outline - Mantine handles focus states */
  button:focus {
    outline: none;
  }

  /* Respect user preferences for reduced motion */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;
